import axios from "axios";

const baseURL = "https://api.shipday.com"

export default axios.create({
    baseURL: baseURL
});
